import React from 'react';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import Router from 'app/routes/Router';

import App from './pages/App';
import { history } from './utils/history';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

// TypeScript only:

window.__TANSTACK_QUERY_CLIENT__ = queryClient;

const MainApp = () => (
    <Sentry.ErrorBoundary fallback={'An error has occured'}>
        <Router history={history}>
            <QueryClientProvider client={queryClient}>
                <App />
                {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}
            </QueryClientProvider>
        </Router>
    </Sentry.ErrorBoundary>
);

export default MainApp;
